export default __webpack_public_path__ + "static/media/beach.a83e13a5.png";